<template>
  <div class="logo" :class="{ collapsed: isCollapsed }">
    <div class="logo-image">
      <img :class="[this.theme === 'dark' ? 'logo-image-dark' : 'logo-image-light']"
        @mouseover="showReturnHomepage = true"
        @mouseleave="showReturnHomepage = false"
        @click="returnHomepage()"
        />
      <div v-show="showReturnHomepage" class="return-homepage">回到首页</div>
    </div>
    <div class="logo-text" v-show="!isCollapsed">
      <div :class="this.titleClass" >中建八局</div>
      <div class="logo-subtitle" :class="{light:this.theme!='dark'}">AI智能体中心</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LogoComponent',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showReturnHomepage: false
    };
  },
  computed: {
    titleClass() {
      return this.theme === 'dark' ? 'logo-title' : 'logo-title-light';
    },
    theme() {
      return this.$route.name === 'homepage'|| this.$route.name === 'ProductIntro' || this.$route.name === 'ContactPage' ? 'dark' : 'light';
    }
  },
  methods: {
    returnHomepage() {
      if(this.$route.name != 'homepage')
        this.$router.push({ path: '/homepage' });
    }
  }
}
</script>

<style scoped>
.logo {
  position: fixed;
  display: flex;
  align-items: left;
  left: 18px;
  top: 12px;
  width: 245px;
  height: 71px;  
  z-index: 10;
  transition: width 0.3s ease;
}

.logo.collapsed {
  width: 60px;
}

.logo-image {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  img:hover{  
      cursor: pointer;
      height: 55px;
      width: 55px;
  }
  img{
      height: 50px;
      width: 50px;
  }
  .logo-image-dark {
    content: url('../../assets/images/C8Engine白色Logo.png');
  }
  .logo-image-light {
    content: url('../../assets/images/C8DI Logo.png');
  }

  .return-homepage {
    position: absolute;
    font-family: pingFangSC;
    font-size: 16px;
    background-color: black;
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    margin-top: 60px;
  }
}
.logo-text{
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo-title {
  font-family: pingFangSC;
  font-weight: 600;
  font-size: 18px;
  color:white;}
  .logo-title-light {
  font-family: pingFangSC;
  font-size: 18px;
  font-weight: 600;
  color:black;
}

.logo-subtitle {
  font-family: pingFangSC;
  font-size: 18px;
  font-weight: 600;
  color:#BFF202;

}
  .light{
    color:#1660c0;
  }

}

</style>
